// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8 1.8C5.12 1.8 2.86 3.88 2.42 6.5C1.65 6.65 1.15 7.3 1.15 8.05C1.15 8.8 1.65 9.45 2.42 9.6C3.02 12.41 5.1 14 8 14C10.9 14 12.98 12.41 13.58 9.6C14.35 9.45 14.85 8.8 14.85 8.05C14.85 7.3 14.35 6.65 13.58 6.5C13.42 5.61 13.04 4.8 12.47 4.08',
  'M8 1.8C9.79 1.8 10.9 2.65 10.9 3.8C10.9 4.83 10.2 5.55 9.35 5.55C8.71 5.55 8.2 5.19 8.2 4.65',
  'M5.5 7.5V8.3M10.5 7.5V8.3',
  'M6.2 10.55C7.23 11.35 8.77 11.35 9.8 10.55',
];
